"use client";

import { useEffect } from "react";

import { ADS_CLIENT } from "./config";

export default function AdsBoot() {
  useEffect(() => {
    if (!ADS_CLIENT) return;

    const existing = document.querySelector<HTMLScriptElement>(
      'script[src^="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]'
    );

    if (existing) return;

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADS_CLIENT}`;
    script.crossOrigin = "anonymous";

    document.head.appendChild(script);
  }, []);

  return null;
}